import {
  CSS,
  Express,
  Git,
  Github,
  HTML5,
  Jasmine,
  JavaScript,
  Jira,
  LinkedIn,
  MongoDB,
  NodeJs,
  React,
  TailwindCss,
} from '../assets';
import projects from './projects.jsx';

export const navLinks = [
  {
    id: 'skills',
    title: 'Skills',
  },
  {
    id: 'projects',
    title: 'Projects',
  },
  {
    id: 'contact',
    title: 'Contact',
  },
];

export const techCards = [
  {
    title: 'HTML5',
    Img: HTML5,
    description:
      'Expertise in creating semantic and accessible web pages using the latest HTML5 standards.',
  },
  {
    title: 'CSS',
    Img: CSS,
    description:
      'Proficient in styling responsive and visually appealing web pages using CSS.',
  },
  {
    title: 'JavaScript',
    Img: JavaScript,
    description:
      'Strong foundation in JavaScript for both front-end and back-end development.',
  },
  {
    title: 'React',
    Img: React,
    description:
      'Experienced in building interactive user interfaces and single-page applications using React.',
  },
  {
    title: 'TailwindCss',
    Img: TailwindCss,
    description:
      'Skilled in rapidly designing modern and responsive web layouts with Tailwind CSS.',
  },
  {
    title: 'NodeJs',
    Img: NodeJs,
    description:
      'Proficient in building server-side applications and APIs with Node.js.',
  },
  {
    title: 'Express.js',
    Img: Express,
    description:
      'Skilled in building efficient and scalable web applications with Express.js.',
  },
  {
    title: 'MongoDB',
    Img: MongoDB,
    description:
      'Skilled in managing and querying NoSQL databases using MongoDB.',
  },
  {
    title: 'Git',
    Img: Git,
    description: 'Experienced in version control and collaboration using Git.',
  },
  {
    title: 'Jira',
    Img: Jira,
    description:
      'Experienced in managing projects and tracking tasks using Jira.',
  },
  {
    title: 'Jasmine',
    Img: Jasmine,
    description:
      'Proficient in writing unit and integration tests using the Jasmine testing framework.',
  },
];

export const contactCards = [
  { title: 'Email', data: 'abdullah.ashraf.real@gmail.com', href: 'mailto:abdullah.ashraf.real@gmail.com' },
  { title: 'Whatsapp', data: '+201151890608', href: 'https://wa.me/+201151890608' },
  { title: 'Location', data: 'Egypt' },
];

export const socialLinks = [
  { title: 'LinkedIn', data: 'abdullahashraff', href: 'https://linkedin.com/in/abdullahashraff', Icon: LinkedIn },
  { title: 'Github', data: 'abdullahashraff', href: 'https://github.com/abdullahashraff', Icon: Github },
  // { title: 'X', data: 'abdullahashraff', href: 'https://linkedin.com/in/abdullahashraff', Icon: TwitterX },
];

export { projects };
